import React, { forwardRef } from 'react';

import RetryLaterModalBase from './RetryLaterModalBase';
import { useDataContext } from '../../context/useDataContext';
import { CheckDataStatus } from '../../@types/checkData';
import { STATS_EVENTS, sendStats } from '../../helpers/sendStats';

// typograf-enable
export default forwardRef<HTMLInputElement>(function RetryLaterModal(_, comboboxRef) {
  const { checkDataStatus, searchValue, setCheckDataStatus, debouncedGetAddress } =
    useDataContext();

  if (checkDataStatus !== CheckDataStatus.TechError) {
    return null;
  }

  const handleRetry = () => {
    sendStats(STATS_EVENTS.ERROR_MODAL, 'Повторить');
    setCheckDataStatus(CheckDataStatus.Initial);
    debouncedGetAddress({ query: searchValue.trim() });
    if (comboboxRef != null && typeof comboboxRef !== 'function') {
      comboboxRef.current?.focus();
    }
  };

  const handleClose = () => {
    setCheckDataStatus(CheckDataStatus.Initial);
  };

  return <RetryLaterModalBase onRetry={handleRetry} onClose={handleClose} />;
});
